import { combineReducers } from 'redux';

import page from './page/reducer';
import report from './report/reducer';

export default combineReducers({ page, report });



// WEBPACK FOOTER //
// ./src/pages/prohibiteditems/state/reducer.js